import { ApiMainFeatures } from 'BackendApi'

// pro pricing column refers/extends basic freemium features, but legacy users can't see freemium column,
// so they don't know which feature are the "basic" onces. To quickly fix this, since it should be a temporary one-off thing, we show a custom hardcoded list to them
export const legacyProFeatures: ApiMainFeatures[] = [
  {
    name: 'Real-Time LEAD SYNC',
    description:
      'How often LeadsBridge syncs your lead information. LeadsBridge runs data sync process in real-time. Sometimes, the process might be slightly delayed due to third-party platforms capabilities.',
  },
  {
    name: '380+ available platforms',
    description:
      'Access our self-service directory of over 380 built-in API integrations of the most popular CRMs, ESP and Marketing software (https://leadsbridge.com/integrations/)',
  },
  {
    name: 'Unlimited Ad Accounts',
    description:
      'Connect unlimited advertising accounts (i.e. Facebook Ads, Google Ads, LinkedIn Ads).',
  },
  {
    name: 'GDPR & CCPA Compliant',
    description:
      'Secure and private by design without storing any sensitive information (https://leadsbridge.com/security/), and meeting major data protection & security regulation requirements',
  },
  {
    name: 'Audience Targeting and Conversions',
    description:
      'Evergreen CRM contacts sync with Facebook Custom Audiences, Instagram Custom Audiences, Google Customer Match and LinkedIn Matched Audiences. Retarget and re-engage with customers that matter ensuring GDPR & CCPA compliance by excluding unsubscribers from retargeting activities.',
  },
  {
    name: 'Premium Integrations',
    description:
      'Premium integrations feature supports custom modules, objects, on-premises versions, including: Adobe Analytics, Adobe Business Catalyst, Adobe Campaign, Bronto, ClickDimensions, DialPad, Exact Target (Salesforce® Marketing Cloud), IBM Silverpop, IBM Watson, Iterable, Marketo, Maropost, Mautic, Microsoft Dynamics CRM, Mixpanel, Netsuite, Oracle Eloqua, Oracle Responsys, Oracle Sales Cloud, Pardot, Redtail, Retention Science, Sailthru, SAP, Segment.com, Selligent, SharpSpring.',
  },
  {
    name: 'Welcome Email/SMS & Email Receipt',
    description:
      'Communicate with your leads as soon as they come in, sending welcome messages via email and SMS.',
  },
  {
    name: 'Email & Zoom Support',
    description:
      'This Standard Support package provides email support during business hours (Monday to Friday from 6 am to 6 pm EST) and scheduled Zoom calls with our Customer Service Team to get things sorted out.',
  },
]
